import { render, staticRenderFns } from "./safetyDataSheetUpload.vue?vue&type=template&id=00c9fb46"
import script from "./safetyDataSheetUpload.vue?vue&type=script&lang=js"
export * from "./safetyDataSheetUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports